// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__39_hk","action":"styles_action__2Ox23"};